import { render, staticRenderFns } from "./OnlineTestView.vue?vue&type=template&id=2c0e43a8"
import script from "./OnlineTestView.vue?vue&type=script&lang=js"
export * from "./OnlineTestView.vue?vue&type=script&lang=js"
import style0 from "./OnlineTestView.vue?vue&type=style&index=0&id=2c0e43a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports